<template>
    <div class="sets-header hidden-print" :class="{'company-page':env.isCompanyDomain}">
        <div class="enterprise-tip" v-if="!env.isCompanyDomain">
            <div class="container">
<!--                <div class="left" v-if="isShowType">-->
<!--                    <span><a class="comp" href="company/open/apply">进入企业版</a></span>-->
<!--                    <span class="inline-block vm">开通电话：010-82166778</span>-->
<!--                </div>-->
                <div class="right" v-else>
                    <span><a href="/" target="_blank">首页</a></span>|
<!--                    <span><a href="/store/open/resource" target="_blank">商店</a></span>|-->
<!--                    <span><a href="https://bbs.101test.com" target="_blank">社区</a></span>|-->
                    <span><a href="help/open/index" target="_blank">服务说明</a></span>
                </div>
            </div>
        </div>
        <div class="inner clearfix">
            <a class="logo-wrapper" :title="showTitle" href="/">
                <img class="logo" :src="env.isCompanyDomain ? company.companyLogo : '/assets/img/logo_300_100.png'"
                     alt="百一测评在线考试系统|题库网|试卷网">
            </a>
            <navbar v-if="!companyPath"></navbar>
            <concurrency-tip v-if="!companyPath"></concurrency-tip>
            <login-corner class="fr" v-if="user.login" :invite-list.sync="invited"></login-corner>
            <not-login-corner class="fr" v-else></not-login-corner>
            <notification-box class="fr mr20" v-if="user.login && !companyPath&&!isShowType"></notification-box>
            <button class="btn btn-default fr mr30 mt10" v-if="user.isCompanyAdmin && !isCompanyAdminView"
                    @click="switch2Admin()">进入企业后台
            </button>
        </div>
        <div class="integral" v-if="showIntegral">
            <div class="points" v-if="!needInfo">
                <div class="points-bg"></div>
                <div class="point-text">积分可直接用来购买考试、题库，也可在购买<br />vip会员时抵用一定数量的现金</div>
                <div class="btn-area">
                    <div class="btn btn-primary centain-btn" @click="drawPoints">立即领取</div>
                    <div class="btn pass" @click="cancelPoints">放弃</div>
                </div>
            </div>
            <div class="bind-info" v-if="needInfo">
                <h4>您还没有绑定邮箱或者手机号</h4>
                <div>绑定后可以使用邮箱或者手机号登陆,还可以获得平台赠送的20积分</div>
                <div class="py10">注:积分可直接用来购买考试、题库，也可在购买vip会员时抵用一定数量的现金</div>
                <div class="btn-area">
                    <div class="btn btn-primary centain-btn" @click="goSetting">去绑定</div>
                    <div class="btn pass" @click="closeIntegral">不再提示</div>
                </div>
            </div>
        </div>
        <div class="modal-container" v-if="showIntegral"></div>
    </div>
</template>

<script lang="babel">
    /**
     * Header
     */
    import {user, request, env, company, params} from 'bootsets/runtime'
    import { accountModel } from 'bootsets/models'
    import NotificationBox from './notification-box.vue'
    import Navbar from './navbar.vue'
    import ConcurrencyTip from './concurrency-tip.vue'
    import LoginCorner from './login-corner.vue'
    import NotLoginCorner from './not-login-corner.vue'
    import {isAdminView, switch2AdminView} from './navbar-util'
    export default{
        components: {NotificationBox, Navbar, ConcurrencyTip, LoginCorner, NotLoginCorner},
        props: {},
        data() {
            return {
                env,
                user,
                company,
                // 当前视图是否为管理员视图
                isCompanyAdminView: isAdminView(),
                companyPath: !!request.companyPath,
                currentPageType: +params.pageType || +request.pageType || '',
                showIntegral: false,
                needInfo: false
            }
        },
        computed: {
            isShowType(){
                return this.currentPageType === 1 ||
                        this.currentPageType === 2 ||
                        this.currentPageType === 3 ||
                        showBlackBar
            },
            showTitle() {
                return env.isCompanyDomain ? '' : '百一测评是测.评.练的一站式在线考试系统，稳定、安全、功能强大。平台汇集海量K12题库、913个行业题库以及100多个资格证考试题库，并全部结构化，标注考点难度，题目月均增长超过30万道。'
            }
        },
        methods: {
            // 切换为管理员
            switch2Admin() {
                switch2AdminView()
                window.open('/company/user')
            },
            drawPoints() {
                accountModel.drawPoints().then(() => {
                    this.showIntegral = false
                })
            },
            cancelPoints() {
                accountModel.cancelPoints().then(() => {
                    this.showIntegral = false
                })
            },
            goSetting() {
                this.showIntegral = false
                window.location.replace('/settings/basic-info')
            },
            closeIntegral() {
                this.showIntegral = false
            }
        },
        ready() {
            const _self = this
            if (!window.SETS.user.login || window.SETS.company) {
                return false
            }
            if (!window.sessionStorage['needBind']) {
                return false
            }
            accountModel.getPointsReward().then(function(res) {
                window.sessionStorage.removeItem('needBind')
                if (res === 0) {
                    // 不能领取积分
                    _self.showIntegral = true
                    _self.needInfo = true
                } else if (res === 1) {
                    // 可以领取
                    _self.showIntegral = true
                    _self.needInfo = false
                }

            })
        }
    }
</script>

<style lang="stylus">
    $bg = #ffffff
    $nav-height = 78px
    $com-nav-height = 54px
    $nav-width = 1200px
    .sets-header
        z-index 1020
        background: $bg
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1)
        height: $nav-height
        //line-height: $nav-height - 1px
        //box-sizing border-box
        &.company-page
            height $com-nav-height
        .inner
            min-width: $nav-width
            max-width: $nav-width
            margin: 0 auto
            background: $bg
            .logo-wrapper
                text-align left
        .logo-wrapper
            float: left
            margin-right: 10px
            width 160px
            text-align center
        .logo
            height: 40px
            margin-top 7px
        &.fluid .inner
            min-width 0
        &.auto .inner
            max-width none
            margin 0 10px
        &.auto .enterprise-tip .container
            width auto
        &.fixed
            position fixed
            top 0
            left 0
            right 0
        .integral
            position fixed
            top 50%
            left 50%
            transform translate(-50%, -50%)
            z-index 9999
            background-color: #fff
            border-radius 4px

    .menu-transition
        transition: all .15s ease-in-out
        opacity 1
        transform translateY(0)

    .menu-enter, .menu-leave {
        opacity: 0;
        transform translateY(-10px)
    }
    .point-text {
        text-align center
        padding 20px 0
    }
    .btn-area {
        text-align center
    }
    .points {
        width 350px
        height 280px
        background-color #fff
        z-index 999
        border-radius 4px
    }
    .centain-btn {
        margin-right 30px
    }
    .points-bg {
        height 140px
        width 100%
        background url("../../assets/img/account/get-points.png") no-repeat center
    }
    .modal-container {
        position: fixed
        width: 100%
        height 100%
        top 0
        left 0
        background-color rgba(1,1,1,0.8)
    }
    .bind-info {
        padding 20px
        text-align center
    }
    .bind-info > h4 {
        padding 20px 0
    }
    .py10 {
        padding 10px 0
    }

</style>


// WEBPACK FOOTER //
// sets-header.vue?46ee8742